<h1 matDialogTitle>
    {{ (context.isNewEntry ?
        'role_modal_title_add' :
        'role_modal_title_update') | translate: context.data }}
</h1>

<form *uiContentLoading="!(permissionGroups$ | async).length"
      [formGroup]="form"
      (submit)="onSubmit()">
    <mat-dialog-content #dialog>
        <mat-form-field *ngIf="context.isNewEntry"
                        class="form-group">
            <input [uiAutofocus]
                   [placeholder]="'role_modal_form_name' | translate"
                   matInput
                   formControlName="name"
                   class="form-control"
                   required
                   data-cy="role-name" />
            <mat-hint *ngIf="!form?.get('name')!.pristine &&
                            form?.get('name')!.hasError('maxlength')"
                      [translateParams]="form?.get('name')!.getError('maxlength')"
                      translate
                      class="errorMessage">
                role_modal_form_name_max_warning
            </mat-hint>
        </mat-form-field>

        <ng-container *uiModernContext>
            <mat-accordion>
                <mat-expansion-panel #warning
                                     (opened)="didExpandWarning = true"
                                     class="warning-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon aria-hidden="false"
                                      tabindex="0"
                                      [class.ui-role-modal-warn]="isWarningVisible"
                                      [class.ui-role-modal-info]="!isWarningVisible">
                                {{ isWarningVisible ? 'warning' : 'info' }}</mat-icon>
                            <span class="warning-panel-text">
                                {{ (isWarningVisible ? 'role_modal_global_and_folder_checked_warn_title' : 'role_modal_global_and_folder_checked_info_title') | translate }}
                            </span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <span [innerHTML]="'role_modal_global_and_folder_checked_warn' | translate | nl2br"></span>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-tab-group mat-stretch-tabs>
                <mat-tab [label]="'role_modal_global_permissions' | translate"
                         translate>
                    <ng-container *ngTemplateOutlet="table; context: {
                                    $implicit: globalPermissionGroups$,
                                    actionChecked: globalActionChecked,
                                    folderPermissions: false
                                }">
                    </ng-container>
                </mat-tab>

                <mat-tab [label]="'role_modal_folder_permissions' | translate"
                         translate>
                    <ng-container *ngTemplateOutlet="table; context: {
                                  $implicit: folderPermissionGroups$,
                                  actionChecked: folderActionChecked,
                                  folderPermissions: true
                                }">
                    </ng-container>
                </mat-tab>

            </mat-tab-group>
        </ng-container>

        <ng-container *uiLegacyContext>
            <ng-container *ngTemplateOutlet="table; context: {
                    $implicit: permissionGroups$,
                    actionChecked: globalActionChecked,
                    folderPermissions: null
                }">
            </ng-container>
        </ng-container>

        <ng-template #table
                     let-groups$
                     let-actionChecked="actionChecked"
                     let-folderPermissions="folderPermissions">
            <table [class.disabled]="!context.data.isEditable"
                   class="table table-bordered">
                <thead>
                    <tr>
                        <th></th>
                        <th *ngFor="let action of actions">
                            <mat-checkbox [checked]="actionChecked[action] === 'checked'"
                                          [disabled]="!context.data.isEditable"
                                          [indeterminate]="actionChecked[action] === 'indeterminate'"
                                          (change)="toggleAction(action, folderPermissions)">
                                <span [matTooltip]="'role_toggle_category' | translate: {
                                    name: ('role_modal_' + action | lowercase) | translate | lowercase
                                }">
                                    {{ ('role_modal_' + action | lowercase) | translate }}
                                </span>
                            </mat-checkbox>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let group of groups$ | async">
                        <td>
                            <mat-checkbox [checked]="groupChecked[group.name] === 'checked'"
                                          [indeterminate]="groupChecked[group.name] === 'indeterminate'"
                                          [disabled]="!context.data.isEditable"
                                          (change)="togglePermissionGroup(group)"
                                          [attr.data-cy]="group.name + '.All'"
                                          class="group-checkbox">
                                <span [matTooltip]="'role_toggle_category' | translate: {
                                    name: group.localName | translate | lowercase
                                }">
                                    {{ group.localName | translate }}
                                </span>
                            </mat-checkbox>
                        </td>

                        <td *ngFor="let action of actions">
                            <mat-checkbox [formControlName]="group.name + '.' + action"
                                          [attr.data-cy]="group.name + '.' + action">
                            </mat-checkbox>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button"
                data-cy="role-cancel">
            {{ (context.data.isEditable ? 'modal_action_cancel' : 'modal_action_close') | translate }}
        </button>
        <ng-container *uiModernContext>
            <button *ngIf="shouldReviewWarnings"
                    (click)="reviewWarning()"
                    mat-flat-button
                    type="button"
                    color="warn"
                    data-cy="role-review-warning">
                {{ 'modal_action_review_warning' | translate }}
            </button>
            <ng-container *ngIf="!shouldReviewWarnings">
                <ng-container *ngTemplateOutlet="submitButtonTmpl"></ng-container>
            </ng-container>
        </ng-container>

        <ng-container *uiLegacyContext>
            <ng-container *ngTemplateOutlet="submitButtonTmpl"></ng-container>
        </ng-container>

        <ng-template #submitButtonTmpl>
            <button [spinnerButtonLoading]="state.loading"
                    [disabled]="state.loading ||
                        form?.pristine ||
                        form?.invalid ||
                        !context.data.isEditable"
                    ui-spinner-button
                    mat-flat-button
                    type="submit"
                    color="primary"
                    data-cy="role-submit">
                {{ (context.isNewEntry ? 'modal_action_create' : 'modal_action_update') | translate }}
            </button>
        </ng-template>

    </mat-dialog-actions>
</form>
